// extracted by mini-css-extract-plugin
export default {"list":"styles_list__NZ9mp","watsApp":"styles_watsApp__qbsnt","email":"styles_email__SsfLy","topContacts":"styles_topContacts__fCK37","phone":"styles_phone__m4F7Y"};